<header class="header-container">
  <button class="header-left" (click)="homeRedirection()">
    <img src="/assets/images/PPL-Logo-white.png" alt="PPL First Logo" class="logo" />
    <div class="cpyname">PPL Lead</div>
  </button>
</header>